import React from "react";

import HeroSection from "../components/Home/HeroSection";
import AboutSection from "../components/Home/AboutSection";
import ServicesSection from "../components/Home/ServicesSection";
import WhyChooseSection from "../components/Home/WhyChooseSection";
//import TestimonialSection from "../components/Home/TestimonialSection";
import FeatureCards from "../components/Home/FeatureCards";

const Home = () => {
  return (
    <>
      <HeroSection />
      <FeatureCards />
      <AboutSection />
      <ServicesSection />
      <WhyChooseSection />
      {/* <TestimonialSection /> */}
    </>
  );
};
export default Home;
